import { render, staticRenderFns } from "./SMMortgageBuyingRequests.vue?vue&type=template&id=9e482fb2&"
import script from "./SMMortgageBuyingRequests.vue?vue&type=script&lang=js&"
export * from "./SMMortgageBuyingRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports